// Logo.js
import React from 'react';

const Logo = ({ src, alt, style }) => {
  return (
    <img src={src} alt={alt} style={style} />
  );
};

export default Logo;
